import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41ae1b22&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Section/Index.vue').default,UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default,HearingDiaryPopup: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/HearingDiaryPopup/index.vue').default})
